/*
 * @创建文件时间: 2020-02-01 19:41:08
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-19 14:11:27
 * @联系Qq:1360484677
 * @文件介绍: 
 */
export default [{
        path: 'routeTable',
        name: 'routeTable',
        meta: {
            title: '路线',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/routeTable')
    },
    {
        path: 'roadSectionTable',
        name: 'roadSectionTable',
        meta: {
            title: '国省专线',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/roadSectionTable')
    },
    {
        path: 'roadRural',
        name: 'roadRural',
        meta: {
            title: ' 农村公路',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/roadRural')
    },
    {
        path: 'bdRoadNetworkTable',
        name: 'bdRoadNetworkTable',
        meta: {
            title: '路网',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/bdRoadNetworkTable')
    },
    {
        path: 'bdRouteStructureTable',
        name: 'bdRouteStructureTable',
        meta: {
            title: '路面结构',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/bdRouteStructureTable')
    },
    {
        path: 'bdStructureTemplateTable',
        name: 'bdStructureTemplateTable',
        meta: {
            title: '结构库',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/bdStructureTemplateTable')
    },
    {
        path: 'bdStructureMaterialTable',
        name: 'bdStructureMaterialTable',
        meta: {
            title: '材料库',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/bdStructureMaterialTable')
    },
    {
        path: 'bdSideSlopeTable',
        name: 'bdSideSlopeTable',
        meta: {
            title: '防护设施',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/bdSideSlopeTable')
    },
    {
        path: 'bdDrainageFacilityTable',
        name: 'bdDrainageFacilityTable',
        meta: {
            title: '排水设施',
            auth: true
        },
        component: () =>
            import ('@/views/basic/roadProduction/bdDrainageFacilityTable')
    }
]